/**
 * Normalize address country display / ISO input to an ACCS `country_code` (e.g. `US`).
 *
 * Used when dual-writing `address.country_code` from forms that store `country`
 * ("United States") and when mapping DB rows onto ACCS cart addresses.
 * Empty → `US` (US-only send flow today).
 */
export function normalizeAddressCountryCode(country: string | null | undefined): string | null {
    const raw = country?.trim()
    if (!raw) {
        return 'US'
    }
    if (raw.length === 2) {
        return raw.toUpperCase()
    }
    const lower = raw.toLowerCase()
    if (
        lower === 'united states' ||
        lower === 'united states of america' ||
        lower === 'usa' ||
        lower === 'u.s.' ||
        lower === 'u.s.a.'
    ) {
        return 'US'
    }
    return raw
}
